// extracted by mini-css-extract-plugin
export default {"thumb":"AttachmentListItem_thumb__gfMvW","playIcon":"AttachmentListItem_playIcon__lBGl+"};